// const firebaseUrl = 'http://127.0.0.1:5001/easyros-62675/us-central1/';
export const firebaseUrl =
  'https://us-central1-easyros-62675.cloudfunctions.net/';

let listProducts = async () => {
  try {
    const result = await fetch(firebaseUrl + 'listProducts', {
      method: 'POST'
    });
    if (!result.ok) return [`${result.status}`, false];
    return [(await result.json()).data, true];
  } catch (error) {
    return [`${error}`, false];
  }
};

export { listProducts };
